import type { NetworkInfo } from "@alch/dx-entities";
import NetworkSelect from "@features/network-select/NetworkSelect";
import { useMemo } from "react";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";
import type { ComposerFormState } from "./lib/form.js";
import type { ComposerMethodConfig } from "./lib/methods.js";
import {
  filterMethodNetworkInfos,
  getMethodConfigsByName,
} from "./lib/methods.js";

interface ComposerNetworkSelectProps {
  control: Control<ComposerFormState>;
  networkInfos: NetworkInfo[];
  methodConfigs: ComposerMethodConfig[];
}

const ComposerNetworkSelect = ({
  control,
  networkInfos,
  methodConfigs,
}: ComposerNetworkSelectProps) => {
  const methodName = useWatch({ control, name: "method" });
  const selectedMethodConfigs = useMemo(
    () => getMethodConfigsByName(methodConfigs, methodName),
    [methodConfigs, methodName],
  );

  const methodNetworkInfos = useMemo(
    () => filterMethodNetworkInfos(selectedMethodConfigs, networkInfos),
    [networkInfos, selectedMethodConfigs],
  );

  const availableNetworkInfos = useMemo(
    () =>
      methodNetworkInfos.filter((info) =>
        methodConfigs.some((method) => method.networks.includes(info.id)),
      ),
    [methodNetworkInfos, methodConfigs],
  );

  if (availableNetworkInfos.length === 0) {
    return null;
  }

  return (
    <NetworkSelect
      label="Network"
      control={control}
      networkInfos={availableNetworkInfos}
      name="network"
      placeholder="Select network"
    />
  );
};

export default ComposerNetworkSelect;
